import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isSliderFaded: true,
    isScreenLocked: false,
    isPageLocked: false
  },
  mutations: {
    SHOW_SLIDER: (state) => {
      state.isSliderFaded = false
    },
    HIDE_SLIDER: (state) => {
      state.isSliderFaded = true
    },
    LOCK_SCREEN_CHANGE: (state) => {
      state.isScreenLocked = true
    },
    UNLOCK_SCREEN_CHANGE: (state) => {
      state.isScreenLocked = false
    },
    LOCK_PAGE: (state, val) => {
      state.isPageLocked = val
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    isSliderFaded: (state) => state.isSliderFaded,
    isScreenLocked: (state) => state.isScreenLocked,
    isPageLocked: (state) => state.isPageLocked
  }
})
